var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMissedFilesIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.3335 1.66663H15.0002C15.9168 1.66663 16.6668 2.41663 16.6668 3.33329V16.6666C16.6668 17.5833 15.9168 18.3333 15.0002 18.3333H5.00016C4.0835 18.3333 3.3335 17.5833 3.3335 16.6666L3.35016 6.66663L8.3335 1.66663ZM5.00016 16.6666H15.0002V3.33329H9.02516L5.00016 7.35829V16.6666ZM9.16683 12.5H10.8335V14.1666H9.16683V12.5ZM10.8335 6.66663H9.16683V10.8333H10.8335V6.66663Z",
  fill: "#4E6072"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMissedFilesIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/missed-files-icon.eb2ee863.svg";
export { ForwardRef as ReactComponent };